<button class="btn btn-add" mat-button [matMenuTriggerFor]="menu" [disabled]="disableAction">
  <img src="assets/images/svg/plus.svg" alt="">
  إرسال إشعار
</button>
<mat-menu #menu="matMenu" backdropClass="notification-client-menu">
  <a mat-menu-item (click)="openSendNotificationModal(false)">إشعار داخلي</a>
  <a mat-menu-item (click)="openSendNotificationModal(true)">إشعار مستعرض</a>
</mat-menu>
